<template>
  <span class="relative inline-block bg-splash bg-clip-text bg-center text-transparent">
    <slot />
  </span>
</template>
